module.exports = __webpack_public_path__ + "static/media/p4_2.5dd641cd.png";